import COMMON_LABELS from "../../../../common/locale/ja_JP";

export const LABELS: Record<string, string> = {
    ...COMMON_LABELS,
};

export default LABELS;
